import React from 'react';
import { BarChart3, TrendingUp, Target, Layers, FileDown } from 'lucide-react';

const DEFAULT_TABS = [
  { id: 'overview', label: 'Overview', icon: BarChart3 },
  { id: 'drivers', label: 'Drivers', icon: TrendingUp },
  { id: 'opportunities', label: 'Opportunities', icon: Target },
  { id: 'scenarios', label: 'Scenarios', icon: Layers },
  { id: 'export', label: 'Export', icon: FileDown },
];

export function DashboardTabs({ activeTab, onTabChange, tabs }) {
  const tabItems = tabs || DEFAULT_TABS;
  return (
    <div className="border-b border-border/50 bg-card/20" data-testid="dashboard-tabs">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <nav className="flex gap-0 overflow-x-auto scrollbar-hide -mb-px">
          {tabItems.map((tab) => {
            const Icon = tab.icon;
            const active = activeTab === tab.id;
            return (
              <button
                key={tab.id}
                onClick={() => onTabChange(tab.id)}
                className={`flex items-center gap-1.5 px-4 py-3 text-xs font-medium border-b-2 transition-colors whitespace-nowrap ${
                  active
                    ? 'border-primary text-primary'
                    : 'border-transparent text-muted-foreground hover:text-foreground hover:border-border'
                }`}
                data-testid={`tab-${tab.id}`}
              >
                <Icon className="w-3.5 h-3.5" />
                {tab.label}
              </button>
            );
          })}
        </nav>
      </div>
    </div>
  );
}

export default DashboardTabs;
